module.exports = __webpack_public_path__ + "img/authenticationRed.21d12033.png";